import { render, staticRenderFns } from "./AzureArchitecture.vue?vue&type=template&id=0f1fd6ec&scoped=true"
import script from "./AzureArchitecture.vue?vue&type=script&lang=js"
export * from "./AzureArchitecture.vue?vue&type=script&lang=js"
import style0 from "./AzureArchitecture.vue?vue&type=style&index=0&id=0f1fd6ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1fd6ec",
  null
  
)

export default component.exports